/* EarthBased countdown timer - 10 Aug 2026
   Replaces the Essential Countdown Timer app.

   =====================================================================
   EDIT BELOW THIS LINE - everything you normally need is in one block.
   =====================================================================

   END_DATE
     ''                      -> counts down to midnight IST, restarts daily
     '2026-08-20 23:59'      -> counts down to that exact date and time (IST)
     Format is 'YYYY-MM-DD HH:MM' on a 24-hour clock.

   WHEN_FINISHED
     'hide'   -> the timer disappears once it reaches zero
     'freeze' -> it stays on screen showing 00:00:00
     (ignored when END_DATE is blank, because a daily timer never ends)

   After editing: Online Store > Themes > ... > Edit code >
   assets/eb-countdown.js > Save. Changes are live immediately.
   =====================================================================
*/
(function(){
  'use strict';

  /* ---------------- EDIT THESE ---------------- */
  var END_DATE      = '';
  var WHEN_FINISHED = 'hide';
  var BAR_TEXT      = '\u23F0 Hurry! Offer ends in:';
  var PRODUCT_TITLE = '\u26A1 Limited Stock\u2013Hurry Up!';
  var PRODUCT_TEXT  = 'Sale ends in:';
  var SHOW_ON_BAR     = true;
  var SHOW_ON_PRODUCT = true;
  /* -------------- STOP EDITING HERE ------------ */

  var GREEN = '#4a8e5a';
  var INK   = '#253d4e';
  var IST_OFFSET_MIN = 330; /* UTC+5:30 */

  function istNow(){
    var now = new Date();
    return new Date(now.getTime() + (IST_OFFSET_MIN + now.getTimezoneOffset()) * 60000);
  }

  function parseEndDate(str){
    var m = String(str).trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{2})$/);
    if(!m) return null;
    return new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], 0, 0);
  }

  var fixedEnd = END_DATE ? parseEndDate(END_DATE) : null;
  if(END_DATE && !fixedEnd && window.console){
    console.warn('[eb-countdown] END_DATE could not be read: "' + END_DATE + '". Expected YYYY-MM-DD HH:MM. Falling back to the daily timer.');
  }

  function msRemaining(){
    var i = istNow();
    if(fixedEnd) return fixedEnd - i;
    var next = new Date(i.getFullYear(), i.getMonth(), i.getDate() + 1, 0, 0, 0, 0);
    return next - i;
  }

  function pad(n){ return n < 10 ? '0' + n : String(n); }

  function unit(value, label){
    var wrap = document.createElement('span');
    wrap.style.cssText = 'display:inline-block;text-align:center;min-width:34px';
    var num = document.createElement('span');
    num.textContent = value;
    num.style.cssText = 'display:block;font-weight:700;font-size:inherit;line-height:1.1;font-variant-numeric:tabular-nums';
    var lab = document.createElement('span');
    lab.textContent = label;
    lab.style.cssText = 'display:block;font-size:10px;opacity:.65;letter-spacing:.03em';
    wrap.appendChild(num); wrap.appendChild(lab);
    return wrap;
  }

  function sep(){
    var x = document.createElement('span');
    x.textContent = ':';
    x.style.cssText = 'font-weight:700;line-height:1.1;opacity:.6';
    return x;
  }

  function clock(fontSize){
    var c = document.createElement('span');
    c.style.cssText = 'display:inline-flex;align-items:flex-start;gap:2px;font-size:' + fontSize + ';color:' + INK;
    var h = unit('00','Hrs'), m = unit('00','Mins'), s = unit('00','Secs');
    c.appendChild(h); c.appendChild(sep()); c.appendChild(m); c.appendChild(sep()); c.appendChild(s);
    c._parts = [h.firstChild, m.firstChild, s.firstChild];
    return c;
  }

  var clocks = [], hosts = [], timerId = null;

  function tick(){
    var ms = msRemaining();

    if(ms <= 0){
      if(fixedEnd && WHEN_FINISHED === 'hide'){
        for(var j = 0; j < hosts.length; j++){ hosts[j].style.display = 'none'; }
        clearInterval(timerId);
        return;
      }
      ms = 0;
    }

    var total = Math.floor(ms / 1000);
    var h = Math.floor(total / 3600);
    var m = Math.floor((total % 3600) / 60);
    var s = total % 60;

    for(var i = 0; i < clocks.length; i++){
      var p = clocks[i]._parts;
      p[0].textContent = pad(h);
      p[1].textContent = pad(m);
      p[2].textContent = pad(s);
    }
  }

  function buildBar(){
    if(!SHOW_ON_BAR || document.querySelector('.eb-countdown-bar')) return;
    var bar = document.createElement('div');
    bar.className = 'eb-countdown-bar';
    bar.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:10px;flex-wrap:wrap;padding:7px 12px;background:#ffffff;color:' + INK + ';font-size:15px;line-height:1.2;text-align:center;min-height:44px;box-sizing:border-box';
    var label = document.createElement('span');
    label.textContent = BAR_TEXT;
    label.style.cssText = 'font-weight:600';
    var c = clock('19px');
    clocks.push(c); hosts.push(bar);
    bar.appendChild(label); bar.appendChild(c);
    if(document.body) document.body.insertBefore(bar, document.body.firstChild);
  }

  function buildProduct(){
    if(!SHOW_ON_PRODUCT) return;
    var form = document.querySelector('form.product-buy');
    if(!form || form.querySelector('.eb-countdown-product')) return;
    var box = document.createElement('div');
    box.className = 'eb-countdown-product';
    box.style.cssText = 'margin:16px 0 0;padding:14px 16px;background:#ffffff;border:1px solid #d8f1e5;border-radius:10px;text-align:center;color:' + INK + ';min-height:104px;box-sizing:border-box';
    var t = document.createElement('div');
    t.textContent = PRODUCT_TITLE;
    t.style.cssText = 'font-weight:700;font-size:16px;margin-bottom:2px';
    var sub = document.createElement('div');
    sub.textContent = PRODUCT_TEXT;
    sub.style.cssText = 'font-size:13px;opacity:.75;margin-bottom:6px';
    var c = clock('30px');
    clocks.push(c); hosts.push(box);
    box.appendChild(t); box.appendChild(sub); box.appendChild(c);
    form.appendChild(box);
  }

  function init(){
    buildBar();
    buildProduct();
    tick();
    timerId = setInterval(tick, 1000);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
